export default __webpack_public_path__ + "static/media/pancakeswap.ff6d4908.png";